import Board from "components/projects/Board";
import { OrderQuote, ProjectRegistrationAdm, ProjectCreation } from "pages/project-creation";
import { PilotRegistration } from "pages/forms";

import { Navigate } from "react-router-dom";
import {
  Home,
  ListReports,
  ReportPreview,
  PaymentCancel,
  PaymentSuccess,
  Plans,
  AutoLogout,
  Dashboard,
  Downloads,
  Projects,
  Reports,
  Uploads,
  TourVirtual,
  GemeoDigital,
  Cartografia,
  VideoPlayer,
  PhotoGallery,
  SubscriptionPage,
  GeoTiffViewer,
  BimViewer
} from "pages/projects";

// USER
import { UserProfile, AlterarSenha } from "pages/user";

// ADMIN
//import { Workflow } from "pages/admin";
import { AdminDashboards } from "pages/admin";
import AdminNotifications from "pages/admin/AdminNotifications";
import AdminPainelControle from "pages/admin/AdminPainelControle";
import StripeDashboard from "pages/stripe-dashboard";

const dashboardRoutes = [
  { path: "/order-quote", component: OrderQuote },
  { path: "/dashboard", component: Dashboard },
  { path: "/uploads", component: Uploads },
  { path: "/downloads", component: Downloads },
  { path: "/projects", component: Projects },
  { path: "/projects/board/:id", component: Board },

  //project routes
  { path: "/tour", component: TourVirtual },
  { path: "/gemeo-digital", component: GemeoDigital },
  { path: "/cartografia", component: Cartografia },

  { path: "/perfil", component: UserProfile },
  { path: "/alterar-senha", component: AlterarSenha },
  { path: "/home", component: Home },
  //{ path: "/project/registration", component: ProjectRegistration },
  { path: "/project/registration", component: ProjectCreation },
  { path: "/plans", component: Plans },
  { path: "/subscriptions", component: SubscriptionPage },
  { path: "/videoplayer", component: VideoPlayer },
  { path: "/photogallery", component: PhotoGallery },
  { path: "/geoview", component: GeoTiffViewer },
  { path: "/geotiff", component: GeoTiffViewer },
  { path: "/bim", component: BimViewer },
  { path: "/stripe/success", component: PaymentSuccess },
  { path: "/stripe/cancel", component: PaymentCancel },
  { path: "/reports/list", component: ListReports },
  { path: "/reports/preview", component: ReportPreview },
  { path: "/logout", component: AutoLogout },
  { path: "/reports", component: () => <Navigate to="/projects" replace /> },
  { path: "/pilot-registration", component: PilotRegistration },

  //admin routes -----------------------------------------------

  // path -> admin/project/create
  // path -> admin/stripe/dashboard
  // path -> admin/dashboards (abas Logs e Usuários)

  { path: "/admin/dashboards", component: AdminDashboards },
  { path: "/admin/project/create", component: ProjectRegistrationAdm },
  { path: "/admin/stripe/dashboard", component: StripeDashboard },
  { path: "/admin/notifications", component: AdminNotifications },
  { path: "/admin/painel-controle", component: AdminPainelControle }

  //OLD admin routes
  //{ path: "/project/registration/adm", component: ProjectRegistrationAdm },
  //{ path: "/workflow", component: Workflow },
  //{ path: "/admin/logs-dashboard", component: LogsDashboard },
  //{ path: "/admin/users-dashboard", component: UsersDashboard },
];

export default dashboardRoutes;
